import { Link } from "react-router-dom";
import { homepageData } from "@/mocks/homepage";

export default function ServiceCategories() {
  return (
    <section id="services" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            核心服务
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            四大核心服务板块，全方位满足您的体育运动需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {homepageData.services.map((service) => (
            <Link
              key={service.id}
              to={`/category/${service.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100/70 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${service.icon} text-xl text-primary-500 group-hover:text-white transition-colors duration-300 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">{service.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="flex flex-col gap-2">
                {service.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-check-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}